"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMapboxAccessToken = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    mapboxAccessToken: null,
};
var mapboxSlice = (0, toolkit_1.createSlice)({
    name: 'mapbox',
    initialState: initialState,
    reducers: {
        setMapboxAccessToken: function (state, action) {
            state.mapboxAccessToken = action.payload;
        },
    },
});
exports.setMapboxAccessToken = mapboxSlice.actions.setMapboxAccessToken;
exports.default = mapboxSlice.reducer;
